import React from 'react';
import flex from '@/css/module/flex.css';
import styles from '@/css/module/new-world.css';

export const WelcomeMessage: React.FC<{ getStarted: boolean }> = ({
  getStarted,
}) => {
  if (getStarted) {
    return (
      <div className={`${flex.column} ${styles.welcome}`}>
        <div className={`${flex.row} ${flex.alignItemsCenter}`}>
          <h1>
            Let's build a query{' '}
            <img
              width="50"
              height="50"
              style={{ width: '50px', height: 'auto', marginTop: '-5px' }}
              src="/img/rocket-border-full.png"
            />
          </h1>
        </div>
        <h4>
          Get started by clicking the <b>Start new query</b> button.
        </h4>
      </div>
    );
  }
  return (
    <div className={`${flex.column} ${styles.welcome}`}>
      <h4>
        <b>Choose a table</b>
      </h4>
    </div>
  );
};
